module.exports = __webpack_public_path__ + "static/media/Jobcase_logo.90abf7d8.svg";